import { TDeliveryProvider } from "../../types/delivery-provider";

/**
 * Logistic providers are a constant catalog (carrier code -> tracking link
 * template), so they are embedded here and read locally instead of calling
 * logistic-gateway. This mirrors the catalog snapshot embedded in sub-purchases
 * (logistic-providers.json) and removes backoffice's runtime dependency on the
 * logistic-gateway /providers endpoint.
 */
const DELIVERY_PROVIDERS: TDeliveryProvider[] = [
  { code: "SERVIENTREGA", name: "Servientrega", trackingLink: "https://mobile.servientrega.com/WebSitePortal/RastreoEnvioDetalle.html?Guia=%s" },
  { code: "COORDINADORA", name: "Coordinadora", trackingLink: "https://coordinadora.com/rastreo/rastreo-de-guia/detalle-de-rastreo-de-guia/?guia=%s" },
  { code: "JOHN_ACERO", name: "John Acero", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "LAST_CARGO", name: "Last Cargo", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "COMERCIAL", name: "Comercial", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "SUPPLIER", name: "Distribuidor", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "ENVIA", name: "Envia", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "ELSA_RIVERA", name: "Transrivera", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "TRACKING", name: "Seguimiento", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "JUAN_CALI", name: "Juan Carlos Hernandez - Cali", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "ANDRES_CARVAJAL", name: "Andres Carvajal - Cali", trackingLink: "https://seeri.store/tracking/%s" },
  { code: "MENSAJERO_CALI", name: "Mensajero Cali", trackingLink: "https://seeri.store/tracking/%s" },
];

export const getDeliveryProviders = async (): Promise<TDeliveryProvider[]> => {
  return DELIVERY_PROVIDERS;
};
